/* eslint import/prefer-default-export: "off" */
/*eslint no-useless-escape: "off"*/
import { includes, map, replace, toLower, toUpper, trim } from 'lodash'

export class CSSSelector {
  private selectorName = ''
  private tagName = ''
  constructor(name: string, tagName?: keyof HTMLElementTagNameMap) {
    this.selectorName = name
    this.tagName = tagName || ''
  }
  get value() {
    return this.selectorName
  }
  get id() {
    return `#${this.selectorName}`
  }
  get classname() {
    return `.${this.selectorName}`
  }
  get role() {
    return `${this.tagName}[role="${this.selectorName}"]`
  }
}

/**
 * Replaces spaces with the specified delimiter
 *
 * Note: This method is based on String#replace.
 * @param str The string to convert.
 * @param prefix When to use the prefix.
 * @param delimiter When to use the prefix.
 * @param transform Transform to upper or lower.
 * @return Returns the modified string.
 */
export const getHtmlSelectorValueBy = (
  str: string,
  prefix = '',
  delimiter = '',
  transform: 'lower' | 'upper' | 'none' = 'none'
) => {
  const replaced = replace(
    `${prefix}${replace(
      trim(str || ''),
      /\`|\~|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\+|\=|\[|\{|\]|\}|\||\\|\'|\<|\,|\.|\>|\?|\/|\""|\;|\:|\s/g,
      delimiter
    )}`,
    /_*$/,
    ''
  )
  if (transform === 'lower') {
    return toLower(replaced || '')
  }
  if (transform === 'upper') {
    return toUpper(replaced || '')
  }
  return replaced
}

/**
 * Replaces spaces to _ and convert to lowercase
 *
 * Note: This method is based on String#replace.
 * Use when we need to get a role by label
 * @param str The string to convert.
 * @param prefix When to use the prefix.
 * @param as Get as value or object. Default: 'value'
 * @return Returns the modified string.
 */
export const getHTMLRoleBy = (
  str: string,
  prefix = '',
  as: 'value' | 'object' = 'value'
) => {
  const role = getHtmlSelectorValueBy(str, prefix, '_', 'lower')
  if (as === 'value') {
    return role
  }
  return { role }
}

export const getNodeText = node => {
  if (includes(['string', 'number'], typeof node)) return node
  if (node instanceof Array) return map(node || [], getNodeText).join('')
  if (typeof node === 'object' && node)
    return getNodeText(node?.props?.children)
}
